/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */

import styled from 'styled-components';

export const StandartSelectListStyled = styled.div.attrs({
    className: 'multiselect-item__label',
})`
    display: flex;
`;
